import {
  UPDATE_CHAT_INPUT,
  SET_CHAT_PANEL_OPEN,
  TOGGLE_CHAT_PANEL_OPEN,
  SET_INPUT_FIELD_REF,
  UPDATE_DOCUMENT_VISIBILITY,
  LOAD_BRAND_TEXT_SUCCESS,
  SET_SHOW_INTRO,
  NAVIGATE_TO_INTRO
} from './actions';
import { SEND_MESSAGE } from '../history/actions';

const initialState = {
  chatInput: '',
  chatPanelVisible: false,
  documentVisible: true,
  inputFieldRef: null,
  showIntro: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CHAT_INPUT:
      return {
        ...state,
        chatInput: action.value
      };
    case SET_CHAT_PANEL_OPEN:
      return {
        ...state,
        chatPanelVisible: action.visible
      };
    case TOGGLE_CHAT_PANEL_OPEN:
      return {
        ...state,
        chatPanelVisible: !state.chatPanelVisible,
        showIntro: action.shouldShowIntro ? true : state.showIntro
      };
    case SEND_MESSAGE:
      return {
        ...state,
        chatInput: ''
      };
    case SET_INPUT_FIELD_REF:
      return {
        ...state,
        inputFieldRef: action.ref
      };
    case UPDATE_DOCUMENT_VISIBILITY:
      return {
        ...state,
        documentVisible: action.visible
      };
    case LOAD_BRAND_TEXT_SUCCESS: {
      return {
        ...state,
        brandText: action.payload.brandText,
        brandLink: action.payload.brandLink
      };
    }
    case SET_SHOW_INTRO:
      return {
        ...state,
        showIntro: action.show
      };
    case NAVIGATE_TO_INTRO:
      return {
        ...state,
        showIntro: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ui/reducer.js